import { Component, Input } from '@angular/core';
import { Message } from '../../interfaces/message';
import { IconService } from '../../services/icon.service';

@Component({
  selector: 'app-recent-messages',
  templateUrl: './recent-messages.component.html',
  styleUrls: ['./recent-messages.component.scss']
})
export class RecentMessagesComponent {
  @Input() messages: Message[] = [];
  @Input() title:string = '';
  @Input() set iconUrl(value: string) {
    this.iconService.addIconToRegistry({
      key: value,
      path: value,
    });
    this.icon = value;
  };
  @Input() noMessagesText: string = '';
  
  icon: string = '';
  
  constructor( private iconService: IconService) {}

  breakpoints = {
    0: {
      slidesPerView: 'auto',
      centeredSlides: true
    },
    768: {
      slidesPerView: 3,
      centeredSlides: false
    },
    1200: {
      slidesPerView: 4,
    },
  };
}
